import React from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EnquireModal({ open, onClose, item = "", kind = "enquire" }) {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState("");
  const [done, setDone] = React.useState(false);
  const firstFieldRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      setError("");
      setDone(false);
      document.body.style.overflow = "hidden";
      setTimeout(() => firstFieldRef.current?.focus(), 80);
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  React.useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && open) onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim() || !email.trim()) {
      setError("Please share your name and email.");
      return;
    }
    setBusy(true);
    try {
      const res = await fetch(`${API}/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name.trim(), email: email.trim(), message: message.trim() || null, item, kind }),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Request failed (${res.status})`);
      }
      setDone(true);
      setName(""); setEmail(""); setMessage("");
    } catch (err) {
      setError("Something didn't go through. Please email hey@komorebidesign.com directly.");
      if (process.env.NODE_ENV !== "production") console.error(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="enq-overlay" onClick={onClose} data-testid="enquire-overlay" role="dialog" aria-modal="true">
      <div className="enq-modal" onClick={(e) => e.stopPropagation()} data-testid="enquire-modal">
        <button className="enq-close" onClick={onClose} aria-label="Close" data-testid="enquire-close">×</button>

        {!done ? (
          <>
            <p className="enq-eyebrow">{kind === "contact" ? "A quiet hello" : `Enquire — ${item}`}</p>
            <h2 className="enq-title">The first conversation<br/>is always <em>free.</em></h2>
            <p className="enq-sub">{kind === "contact" ? "Tell us what you're working on. No brief needed — just the problem you're trying to solve." : "Leave your details. Ishita reads every message and replies within two working days."}</p>

            <form onSubmit={submit} className="enq-form">
              <label className="enq-field">
                <span>Your name</span>
                <input ref={firstFieldRef} type="text" value={name} onChange={(e) => setName(e.target.value)} required maxLength={200} data-testid="enquire-name" />
              </label>
              <label className="enq-field">
                <span>Email</span>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="enquire-email" />
              </label>
              <label className="enq-field">
                <span>{kind === "contact" ? "What are you trying to change?" : "Anything you'd like us to know? (optional)"}</span>
                <textarea rows={4} value={message} onChange={(e) => setMessage(e.target.value)} maxLength={2000} data-testid="enquire-message" />
              </label>
              {error && <p className="enq-error" data-testid="enquire-error">{error}</p>}
              <button type="submit" className="enq-submit" disabled={busy} data-testid="enquire-submit">
                {busy ? "Sending…" : "Send"}
              </button>
              <p className="enq-fineprint">By sending, you agree we'll reply by email. We never share details. Promise.</p>
            </form>
          </>
        ) : (
          <div className="enq-success" data-testid="enquire-success">
            <p className="enq-eyebrow">Sent.</p>
            <h2 className="enq-title">Thank you. <em>Truly.</em></h2>
            <p className="enq-sub">A confirmation just landed in your inbox. Ishita will reply within two working days.</p>
            <button className="enq-submit" onClick={onClose} data-testid="enquire-done">Close</button>
          </div>
        )}
      </div>
    </div>
  );
}
